import { BaseNumberIdDataDto } from '../../../classes/common';
export class ReservationPaymentWithFeeOnlyDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.fee = initializer.fee;
    }
}
